export default __webpack_public_path__ + "static/media/webdevelopimg.14b176bc.png";